import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { DonationsStyled } from '../../../asset/styled/deductions/DonationsStyled';
import titleImg from '../../../asset/img/donations_title_img.svg';

import DonationsItemSection from './DonationsItemSection';
import SubTitleSection from '../../../components/SubTitleSection';
import InfoBanner from '../../../components/Banner';
import TotalSection from '../../../components/TotalSection';
import {
  getDonationInfo,
  resetDonationState,
  setDetailReload,
  setSelectedDonationDetail,
} from './doncationSlice';
import DonationsDetail from './detail';

const Donations = () => {
  const { t } = useTranslation('deductions/donations');
  const dispatch = useDispatch();
  const { dataList, isRender, reload, total } = useSelector(state => state.donation);
  const [isOpen, setIsOpen] = useState(false);

  //초기 데이터 호출
  useEffect(() => {
    dispatch(getDonationInfo());
  }, []);

  //저장, 삭제시 재호출
  useEffect(() => {
    if (reload != -1) {
      dispatch(getDonationInfo());
    }
  }, [reload]);

  //언마운트시 초기화
  useEffect(() => {
    return () => {
      dispatch(resetDonationState());
    };
  }, [dispatch]);

  const onOpen = () => {
    dispatch(setDetailReload(-1));
    setIsOpen(true);
  };
  const onClose = () => {
    // dispatch(setSelectedDonationDetail({}));
    setIsOpen(false);
  };

  return (
    <DonationsStyled>
      <InfoBanner title={t('bannerSection.title')} description={t('bannerSection.description')} />
      <SubTitleSection title={t('title')} img={titleImg} />
      <DonationsItemSection onOpen={onOpen} />
      {/* 합계 */}
      <TotalSection total={total} />
      {/* 상세보기 */}
      <DonationsDetail isOpen={isOpen} onClose={onClose} />
    </DonationsStyled>
  );
};

export default Donations;
